import { Pressable, View, StyleSheet } from 'react-native';
import { Icon, Text } from 'react-native-paper';

import { unisonColors } from '@/theme';

interface RecordingControlButtonProps {
  readonly icon: string;
  readonly label: string;
  readonly onPress: () => void;
  readonly accessibilityLabel?: string;
  readonly disabled?: boolean;
  readonly variant?: 'default' | 'stop';
}

const VARIANT_STYLES = {
  default: {
    backgroundColor: unisonColors.borderNdBase,
    iconColor: unisonColors.textNdPrimary,
    size: 66,
  },
  stop: {
    backgroundColor: unisonColors.errorContainer,
    iconColor: unisonColors.error,
    size: 68,
  },
} as const;

const ICON_SIZE = 32;
const LABEL_COLOR = unisonColors.textNdPrimary;

export const RecordingControlButton = ({
  icon,
  label,
  onPress,
  accessibilityLabel,
  disabled,
  variant = 'default',
}: RecordingControlButtonProps) => {
  const { backgroundColor, iconColor, size } = VARIANT_STYLES[variant];

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? label}
      style={styles.wrapper}>
      <View
        style={[
          styles.circle,
          { backgroundColor, width: size, height: size, borderRadius: size / 2 },
        ]}>
        <Icon source={icon} size={ICON_SIZE} color={iconColor} />
      </View>
      <Text variant="labelLarge" style={styles.label}>
        {label}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    gap: 10,
  },
  circle: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    color: LABEL_COLOR,
  },
});
